module.exports = __webpack_public_path__ + "static/media/km.e0df62e4.svg";